import React, { useEffect, useState } from 'react';

import { Button, List } from 'antd';

import productService from 'v2/services/product';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  file: any;
  onRemove: any;
  index: any;
  itemIndex: any;
}

const File: React.FC<IProps> = ({ file, onRemove, index, itemIndex }) => {
  const [fileName, setFileName] = useState<any>(null);

  useEffect(() => {
    let cancelled = false;
    const fileId = typeof file === 'object' ? file?.upload_id : file;

    if (fileId && !file?.name) {
      (async () => {
        try {
          const response = await productService.loadFileById(fileId);
          if (!cancelled) setFileName(response?.data);
        } catch {
          if (!cancelled) setFileName({ name: `Arquivo #${fileId}`, extension: '' });
        }
      })();
    }

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nameFile = (f: any) => {
    if (f && !f.name) return fileName?.name ? `${fileName.name}.${fileName.extension}` : 'Carregando...';
    return f.name;
  };

  return (
    <List.Item
      className='border-outline-default mb-3 rounded-xl border bg-(--uizz-antd-color-bg-container) px-4 py-3'
      actions={[
        <Button
          key='remove'
          type='text'
          className='m-0'
          icon={<Icon.Trash2 size={16} className='size-4' />}
          onClick={() => onRemove(nameFile(file), itemIndex, index)}
        />
      ]}
    >
      <List.Item.Meta
        className='items-center'
        avatar={
          <div className='flex size-10 items-center justify-center'>
            <Icon.FileText size={28} className='size-7' />
          </div>
        }
        title='Arquivo'
        description={nameFile(file)}
      />
    </List.Item>
  );
};

export default File;
